export default function ProductPage() {
  return <h1>Reports Page</h1>;
}